export default __webpack_public_path__ + "locales/es/PDFFormDialog.json?hash=fb2fafddc492b81764f826d8e44fdffe";